import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../config/api';

interface AppState {
  isMaintenanceMode: boolean;
  maintenanceChecked: boolean;
}

const initialState: AppState = {
  isMaintenanceMode: false,
  maintenanceChecked: false,
};

export const fetchMaintenanceStatus = createAsyncThunk<boolean, void>(
  'app/fetchMaintenanceStatus',
  async () => {
    try {
      const res = await api.get<{ success: boolean; data: { isMaintenanceMode: boolean } }>(
        '/settings/public/maintenance'
      );
      return res.data?.data?.isMaintenanceMode ?? false;
    } catch {
      return false; // on error, assume site is live (fail-open)
    }
  }
);

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setMaintenanceMode(state, action: { payload: boolean }) {
      state.isMaintenanceMode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMaintenanceStatus.fulfilled, (state, action) => {
      state.isMaintenanceMode = action.payload;
      state.maintenanceChecked = true;
    });
    builder.addCase(fetchMaintenanceStatus.rejected, (state) => {
      state.maintenanceChecked = true;
    });
  },
});

export const { setMaintenanceMode } = appSlice.actions;
export default appSlice.reducer;
